import { render, staticRenderFns } from "./createBigExcellence.vue?vue&type=template&id=0f8f3b48&"
import script from "./createBigExcellence.vue?vue&type=script&lang=js&"
export * from "./createBigExcellence.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports